<template>
  <div class="upload">
    <h2 style="text-align: center; margin-bottom: 20px">Upload a research paper for community annotation</h2>
    <div class="container-fluid">
      <template v-if="showSuccess">
        <div class="row justify-content-md-center">
          <div class="col-md-12">
            <b-alert variant="success" show>Successful Submission</b-alert>
          </div>
        </div>
      </template>
      <template v-if="showAlert">
        <div class="row justify-content-md-center">
          <div class="col-md-12">
            <b-alert variant="danger" show>One or more fields are missing</b-alert>
          </div>
        </div>
      </template>
      <div class="row justify-content-md-center" style="margin-top: 20px;">
        <div class="col-md-2">
          <label>Title of the paper</label>
        </div>
        <div class="col-md-5">
          <b-form-input v-model="title" type="text" placeholder="Enter title here" />
        </div>
      </div>
      <div class="row justify-content-md-center" style="margin-top: 20px;">
        <div class="col-md-2">
          <label>Authors of the paper</label>
        </div>
        <div class="col-md-5">
          <b-form-input v-model="authors" type="text" placeholder="Enter authors here" />
        </div>
      </div>
      <div class="row justify-content-md-center" style="margin-top: 20px;">
        <div class="col-md-2">
          <label>Category of the paper (e.g. Physics, ML...)</label>
        </div>
        <div class="col-md-5">
          <b-form-input v-model="category" type="text" placeholder="Enter category here" />
        </div>
      </div>
      <div class="row justify-content-md-center" style="margin-top: 20px;">
        <div class="col-md-2">
          <label>Abstract of the paper</label>
        </div>
        <div class="col-md-5">
          <b-form-textarea :rows="3" v-model="abstract" type="text" placeholder="Enter abstract here" />
        </div>
      </div>
      <div class="row justify-content-md-center" style="margin-top: 55px;">
        <div class="col-md-6">
        <input type="file" accept="application/pdf" @change="detectFiles($event.target.files)" />
        <div class="progress-bar" :style="{ width: progressUpload + '%'}">{{ progressUpload }}%</div>
        </div>
      </div>
      <div class="row justify-content-md-center" style="margin-top: 35px;">
        <button class="btn btn-primary" @click="submitPaper">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import { db } from '@/main';

export default {
  data () {
    return {
      progressUpload: 0,
      file: File,
      uploadTask: '',
      title: '',
      authors: '',
      category: '',
      abstract: '',
      fileRef: '',
      showAlert: false,
      showSuccess: false,
    }
  },
  methods: {
    detectFiles (fileList) {
      if (fileList.length > 0) {
        this.upload(fileList[0])
      }
    },
    upload (file) {
      console.log("before error");
      var storageRef = firebase.storage().ref();
      // point to submittedPapers folder
      var submittedPapersRef = storageRef.child('submittedPapers');
      var fileUploadRef = submittedPapersRef.child(firebase.auth().currentUser.uid + '---' + file.name);
      this.uploadTask = fileUploadRef.put(file);
      this.fileRef = firebase.auth().currentUser.uid + '---' + file.name

    },
    submitPaper() {
      if (
        this.title.length == 0 ||
        this.authors.length == 0 ||
        this.category.length == 0 ||
        this.abstract.length == 0 ||
        this.fileRef.length == 0
      ) {
        this.showAlert = true;
        console.log("missing fields")
        return;
      }
      this.showAlert = false;
      this.showSuccess = true;
      db.collection('papers').add({
        title: this.title,
        authors: this.authors,
        category: this.category,
        abstract: this.abstract,
        fileReference: this.fileRef,
        userId: firebase.auth().currentUser.uid,
        upVotes: [firebase.auth().currentUser.uid],
        downVotes: [],
      });
      this.title = '';
      this.authors = '';
      this.category = '';
      this.abstract = '';
      this.fileRef = '';
      mixpanel.track("click", {"name": "upload paper button"})
    }
  },
  watch: {
    uploadTask: function() {
      this.uploadTask.on('state_changed', sp => {
        this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
      },
      null,
      () => {
        this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
          this.$emit('url', downloadURL)
        })
      })
    }
  }
}
</script>
